export enum Gender {
    Unknown = -1,
    Male = 1,
    Female = 2
}